module.exports = __webpack_public_path__ + "static/img/ktv1.dce9f5bc.png";